/* ==========================================================
   Ohbuku Valley — 和文見出しの折り返し調整
   - 日本語は単語の途中でも折り返せるため、見出しが「求め / て」のように
     1〜2 文字だけ次の行へ落ちることがある
   - Intl.Segmenter で単語に分け、助詞・送り仮名・句読点を直前の語にまとめた
     「文節」単位の塊(.cst-nb = inline-block)にして、塊の途中では折り返さない
   - 行の長さを揃える指定(text-wrap: balance)は assets/custom.css 側
   - 日本語ページのみ。Intl.Segmenter 非対応ブラウザでは何もしない(従来どおりの折り返し)
   ========================================================== */
(function () {
  'use strict';

  if (document.documentElement.lang !== 'ja') return;
  if (!window.Intl || !Intl.Segmenter) return;

  var SELECTOR = [
    '.cst-heading',
    '[class^="cst-"][class*="__heading"]',
    '.cst-story-hero__title',
    '.cst-story-hero__lead',
    '.cst-index-hero__title',
    '.cst-blog-hero__title',
    /* 中央揃えのリード文(行末に句読点が来やすい) */
    '.cst-index-hero__tagline',
    '.cst-index-story__body p',
    '.cst-contact-hero__lead',
    '.cst-news__text',
    /* 案内カード(幅が狭く、単語の途中で折り返しやすい) */
    '.cst-cta__card-title',
    '.cst-cta__card-text'
  ].join(',');

  var MAX_CHUNK = 10; /* これより長い塊は固めない(狭い画面ではみ出すのを防ぐ) */
  /* ひらがな・長音・閉じ括弧・句読点だけの語は直前の語に付ける */
  var TAIL = /^[぀-ゟー、。，．・！？!?）」』】〕…]+$/;
  var OPEN_END = /[（「『【〔]$/;
  var DIGIT_END = /[0-9０-９]$/;
  var PUNCT_END = /[、。，．]$/;
  var GLUE_MAX = 7; /* ひらがなを前の語へ付け足すのはこの長さまで */
  var PREFIX = /^[おご]$/;
  var SUFFIX = /^[的性化]$/;
  var PUNCT_ONLY = /^[、。，．・！？!?）」』】〕…]+$/;

  var segmenter = new Intl.Segmenter('ja', { granularity: 'word' });

  function toChunks(text) {
    var chunks = [];
    var current = '';
    var it = segmenter.segment(text)[Symbol.iterator]();
    for (var r = it.next(); !r.done; r = it.next()) {
      var s = r.value.segment;
      if (/^\s+$/.test(s)) {
        if (current) { chunks.push(current); current = ''; }
        chunks.push(s);
      } else if (PREFIX.test(s)) {
        /* 接頭の「お」「ご」は直前ではなく次の語に付ける(お問い合わせ / ご相談) */
        if (current) chunks.push(current);
        current = s;
      } else if (current && SUFFIX.test(s)) {
        /* 接尾の「的」「性」などは必ず直前の語に付ける(継続|的 と切らない) */
        current += s;
      } else if (current && (TAIL.test(s) || OPEN_END.test(current) || DIGIT_END.test(current) || PREFIX.test(current))) {
        /* ひらがなが続いて塊が長くなりすぎるときは、そこで区切る(お問い合わせ|ください。)。
           長い塊は固められず、語の途中で折り返してしまうため。句読点だけは必ず前に付ける */
        if (current.length + s.length > GLUE_MAX && !PUNCT_ONLY.test(s) && !PREFIX.test(current) && !OPEN_END.test(current)) {
          chunks.push(current);
          current = s;
        } else {
          current += s;
        }
      } else {
        if (current) chunks.push(current);
        current = s;
      }
    }
    if (current) chunks.push(current);
    return chunks;
  }

  function wrapTextNode(node) {
    var text = node.nodeValue;
    if (!text || !text.trim()) return;
    var frag = document.createDocumentFragment();
    toChunks(text).forEach(function (chunk) {
      if (/^\s+$/.test(chunk) || chunk.length > MAX_CHUNK) {
        frag.appendChild(document.createTextNode(chunk));
        return;
      }
      var span = document.createElement('span');
      span.className = 'cst-nb';
      /* 末尾の句読点は字面が左半分だけで右半分が空白のため、中央揃えの行末に来ると
         行全体が左へずれて見える。.cst-punct で印を付け、markPunct() が詰めるか判定する */
      var m = chunk.match(PUNCT_END);
      if (m) {
        span.textContent = chunk.slice(0, -m[0].length);
        var punct = document.createElement('span');
        punct.className = 'cst-punct';
        punct.textContent = m[0];
        span.appendChild(punct);
      } else {
        span.textContent = chunk;
      }
      frag.appendChild(span);
    });
    node.parentNode.replaceChild(frag, node);
  }

  /* 句読点が全角幅のまま(= そのフォントに palt が無い / 効いていない)なら .is-full を付け、
     CSS で右半分の空白を詰める。palt が効くフォントでは既に半角幅なので何もしない */
  function markPunct(el) {
    el.querySelectorAll('.cst-punct').forEach(function (p) {
      var size = parseFloat(getComputedStyle(p).fontSize) || 0;
      if (!size) return;
      p.classList.toggle('is-full', p.getBoundingClientRect().width > size * 0.75);
    });
  }

  function apply(root) {
    root = root && root.querySelectorAll ? root : document;
    root.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.hasAttribute('data-cst-nb')) return;
      el.setAttribute('data-cst-nb', '');
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(wrapTextNode);
      /* 幅の判定は Web フォントの読み込み後に行う */
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { markPunct(el); });
      } else {
        markPunct(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { apply(document); });
  } else {
    apply(document);
  }
  document.addEventListener('shopify:section:load', function (event) { apply(event.target); });
})();
